import i18n from 'src/i18n'
import { LiveStatus, useLiveDate } from 'src/pages/CommunityDetails/Posts/live'
import { LiveIcon } from 'src/components'
import { Tag } from './feedCardLiveBar.styles'
import { FeedCardLiveBarProps } from './feedCardLiveBar.types'

const FeedCardLiveBar = ({ post }: FeedCardLiveBarProps) => {
  const startAt = useLiveDate(post?.live?.startAt)
  const endAt = useLiveDate(post?.live?.endAt)

  return (
    <div className="_d-flex _align-items-center _px-4 _mb-2">
      {post?.live?.status === LiveStatus.STARTED && (
        <Tag className="_d-flex _align-items-center _p-1 _font-14 _text-red-lighter _bg-red-darkest _rounded">
          <LiveIcon />
          {i18n.t('live.in_live')}
        </Tag>
      )}

      <span className="_text-blue-light _ml-auto">
        {post?.live?.status === LiveStatus.COMPLETED ? endAt : startAt}
      </span>
    </div>
  )
}

export default FeedCardLiveBar
